import AbsComponent from "../../components/AbsComponent";

export default class Radio extends AbsComponent{
    constructor(_name='', _store={}, _actions={}, _router={}, _el='', _watch, _api){
        super(_name, _store, _actions, _router, _el);

        this.watchd = _watch;
        this.api = _api;

        this.setting();

        let watchD = this.watch(this.store.getState, this.watchd, this.isEqual);
        this.store.subscribe( watchD( (newVal, oldVal, path) => this.render(newVal, oldVal, path)));
    }

    setting() {
        const { config } = this.store.getState();

        axios( {
            method: 'GET',
            url: `${config.apiDomain}${this.api}`,
            params: { locale: config.locale }
        })
        .then( (_res) => {
            _res.data.unshift({id: "all", name: config.l10n['common.filter.all']});

            let template = _res.data.map( (it, idx) => {
                return `
                <span class="radio">
                    <input type="radio" id="${this.watchd}radio_${it.id}" name="${this.watchd}radio" value="${it.id}">
                    <label for="${this.watchd}radio_${it.id}">
                        ${it.name}
                    </label>
                </span>`;
            }).join('');
            jQuery(this.el).append(template);

            this.addEvents();
            this.render();
        })
        .catch( (error, d) => console.log(error,this.name, d) )
        .then( (d) => {} );
    }

    render(_data = {}){
        jQuery(this.el + ` input`).prop('radio', false);

        const watchData = this.store.getState()[this.watchd];
        if (watchData !== '') {
            jQuery(this.el + ` input:radio[value='${watchData}']`).prop('checked', true);
        }else{
            jQuery(this.el + ` input:radio[value='all']`).prop('checked', true);
        }
    }

    addEvents(){
        jQuery(this.el + ' input').on('change', e => {
            let dat = '';
            if ( e.currentTarget.value === 'all' ) {
                dat = '';
            } else {
                dat = jQuery(this.el + ' input:radio:checked').val();
            }

            this.goRouter(dat);
        });
    }
    
    goRouter(_dat){
        this.router.goMultiParam({[this.watchd]: _dat, page: 1});
    }
}